module.exports = __webpack_public_path__ + "static/media/ten.ca11f84a.svg";